<template>
  <div id="subChangeGoodBadType" v-loading="loading">
    <v-container :left="true" :title="title" :height="'0.6rem'" @esc="esc">
      <v-input :config="config" :models="models" :rules="rules" @complete="complete" @esc="esc" ref="models" slot="content"></v-input>
      <v-foot :btn-config="btnConfig" @up="up" @dow="dow" slot="footer"></v-foot>
      <v-foot :btn-config="saveBtnConfig" @saveCon="saveCon" slot="footer"></v-foot>
    </v-container>
  </div>
</template>

<script>
import container from "../../commons/Container"
import input from "../../commons/Input"
import foot from "../../commons/Footer"
import {getBusinessBatchNo, getBusinessNumber, queryTaskManagerUserDetail, saveConversion} from "@/api/change/change";
import baseMixin from "@/mixins/baseMixin";

export default {
  name: "subChangeGoodBadTypeBatch",
  mixins: [baseMixin],
  data() {
    return {
      loading: false,
      title: this.$tj('module.mainMenutitle','module.bar','module.lot'),
      models: {
        // sku: 'HB5900602-2',
        sku: undefined,
        desc: undefined,
        storerKey: undefined,
        company: undefined,
        productDate: undefined,
        lot: undefined,
        qty: undefined,
        uom: undefined
      },
      rules: {
        qty: [
          {required: true, message: this.$ScanPlease('module.transKey'), trigger: " "},
        ],
        uom: [
          {required: true, message: this.$SelectPlease('module.transType'), trigger: " "},
        ]
      },
      btnConfig: [
        {label: this.$t('module.uplot'), invalid: "up", authCode: 'RF032502'},
        {label: this.$t('module.dowlot'), invalid: "dow", authCode: 'RF032503'},
      ],
      saveBtnConfig: [
        {label: this.$t('module.saveCon'), invalid: "saveCon", authCode: 'RF032504'},
      ],
      lotList: [],
      lotLength: 0,
      currentIndex: 0,
      config: [
        {label: this.$t('module.sku'), prop: "sku", disabled: true},
        {label: this.$t('module.desc'), prop: "desc", disabled: true},
        {label: this.$t('module.storerKey'), prop: "storerKey", disabled: true},
        {label: this.$t('module.company'), prop: "company", disabled: false},
        {label: this.$t('module.productDate'), prop: "productDate", disabled: false},
        {label: this.$t('module.gyslot'), prop: "lot", disabled: false},
        {label: this.$t('module.transferqty'), prop: "qty", disabled: false},
        {label: this.$t('module.uom'), prop: "uom", type: "select", disabled: false, options: this.getOptions("/change/getUnitOfMeasurement/" + this.$route.params.data.sku)}
      ]
    }
  },
  methods: {
    esc() {
      this.$router.go(-1);
    },
    up() {

      let lotLength = this.lotLength;
      let currentIndex = this.currentIndex;
      if (lotLength === 1) {
        this.$message.error(this.$t('module.error1'));
      } else if (lotLength > 0 && currentIndex !== 0) {
        this.currentIndex = currentIndex - 1;
        this.models.lot = this.lotList[this.currentIndex];
        // 验证成功子组件调用父组件函数 complete
      } else {
        this.$message.error(this.$t('module.error2'));
      }
    },
    dow() {

      let lotLength = this.lotLength;
      let currentIndex = this.currentIndex;
      if (lotLength === 1) {
        this.$message.error(this.$t('module.error1'));
      } else if (lotLength > 0 && currentIndex !== lotLength) {
        this.currentIndex = currentIndex + 1;
        this.models.lot = this.lotList[this.currentIndex];
      } else {
        this.$message.error(this.$t('module.error2'));
      }
    },
    saveCon() {
      // 验证参数
      this.$refs.models.submit(7, 2);
      // 验证成功子组件调用父组件函数 complete
    },
    getBusinessNumber() {

      getBusinessNumber().then((res)=> {
        let data = res.data;
        if (res.status === 200 && data.returnCode === "200") {
          this.models.transKey = data.data;
        } else {
          return this.$message.error(data.returnMgr);
        }
      });
    },
    getBusinessBatchNo() {

      getBusinessBatchNo(this.models).then((res) => {
        let data = res.data;
        if (res.status === 200 && data.returnCode === "200") {

          let length = data.data.length;
          if (length > 0) {
            this.lotList = data.data;
            this.models.lot = this.lotList[0];
            this.lotLength = length;
          }
        } else {
          return this.$message.error(data.returnMgr);
        }
      });
    },
    queryTaskManagerUserDetail() {

      queryTaskManagerUserDetail().then((res)=> {
        let data = res.data;
        if (res.status === 200 && data.returnCode === "200") {
          if (data.data === 0) {
            this.$message.error(this.$t('module.noOperationPermission'));
            return this.$router.go(-1);
          } else {
            // 调用转移编号
            this.getBusinessNumber();
          }
        } else {
          return this.$message.error(data.returnMgr);
        }
      });
    },
    complete(model, ref, callback) {
      this.loading = true;
      try {
        saveConversion(model).then((res) => {

          let data = res.data;
          if (res.status === 200 && data.returnCode === "200") {
            this.$message.success(this.$t('module.success1')+":"+ model.sku + this.$t('module.success1') );
            this.$router.go(-2);
          } else {
            this.$message.error(data.returnMgr);
          }
        });
      } catch (error) {
        this.$message.error(error)
      } finally {
        this.loading = false;
      }
    }
  },
  mounted() {
    this.models = {
      ...this.models,
      ...this.$route.params.data
    };
    this.getBusinessBatchNo();
  },
  created() {
  },
  components: {
    "v-container": container,
    "v-input": input,
    "v-foot": foot
  }
}

</script>
<style>

</style>